import {Component, Input, OnInit} from '@angular/core';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {AlertController, ModalController} from '@ionic/angular';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {ConfigurationModel} from '../../models/configuration.model';
import {DocumentModel} from '../../models/document.model';
import {SysConfigModel} from '../../models/sys-config.model';
import {FindSystemConfigService} from '../../services/find-system-config.service';
import {DocumentTypes} from '../../definitions/document-types';

@Component({
    selector: 'app-edit-plant-item-modal',
    templateUrl: './edit-plant-item-modal.component.html',
    styleUrls: ['./edit-plant-item-modal.component.scss'],
})
export class EditPlantItemModalComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() equipment: DetaillineDTOModel;
    equipmentTemp: DetaillineDTOModel;
    configuration: ConfigurationModel;
    overrideDescriptionAllowed: SysConfigModel;
    overbookingAllowed: SysConfigModel;

    constructor(private alertController: AlertController,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                public modalController: ModalController,
                private findSysConfigService: FindSystemConfigService,
                private docTypes: DocumentTypes) {
    }

    ngOnInit() {
        console.log(this.equipment);
        this.equipmentTemp = JSON.parse(JSON.stringify(this.equipment));
        this.configuration = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION);
        this.overbookingAllowed = this.findSysConfigService.findSystemSettingByNumber(320);
        this.overrideDescriptionAllowed = this.findSysConfigService.findSystemSettingByNumber(323);
        if (this.document.documentType === this.docTypes.CONTRACTANDCOLLECTION) {
            const tempFromDate = this.equipmentTemp.fromDate;
            this.equipmentTemp.fromDate = this.equipmentTemp.toDate;
            this.equipmentTemp.toDate = tempFromDate;
        }
    }

    calculatePrice() {
        this.equipmentTemp.total = (this.equipmentTemp.weeklyRate - (this.equipmentTemp.weeklyRate * this.equipmentTemp.discount / 100)) * this.equipment.qty;
    }


    async selectDate(type: number) {
        // Type: 1 for fromDate; 2 for toDate.
        let date = null;
        if (type === 1) {
            date = this.equipmentTemp.fromDate;
        } else if (type === 2) {
            date = this.equipmentTemp.toDate;
        }

        const alert = await this.alertController.create({
            header: 'Select Date',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'date',
                    type: 'date',
                    value: this.generateDate(date)
                },
                {
                    name: 'time',
                    type: 'time',
                    value: this.generateTime(date, type)
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        console.log(data);
                        if (type === 1) {
                            this.equipmentTemp.fromDate = this.formDate(data.date, data.time);
                            // this.checkDateConsistency(1);
                        } else if (type === 2) {
                            this.equipmentTemp.toDate = this.formDate(data.date, data.time);
                            // this.checkDateConsistency(2);
                        }
                    }
                }
            ]
        });
        await alert.present();
    }

    formDate(date: string, time: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        const hour = time.substr(0, 2);
        const minute = time.substr(3, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);
        resDate.setHours(+hour, +minute);
        return resDate.toISOString();
    }

    generateDate(date: string) {
        return date.substr(0, 10);
    }

    generateTime(time: string, type: number) {
        if (type === 1) {
            return this.configuration.standardContractTime ?
                this.configuration.standardContractTime : time.substr(11, 2) + ':' + time.substr(14, 2);
        } else if (type === 2) {
            return this.configuration.standardReturnTime ?
                this.configuration.standardReturnTime : time.substr(11, 2) + ':' + time.substr(14, 2);
        } else {
            return time.substr(11, 2) + ':' + time.substr(14, 2);
        }
    }

    checkDateConsistency(index: number) {
        if (index === 1) {
            if (this.equipmentTemp.fromDate !== this.document.scheduledDate) {
                this.document.scheduledDate = this.equipmentTemp.fromDate;
            }
            if (this.equipmentTemp.toDate < this.document.scheduledDate) {
                this.equipmentTemp.toDate = this.document.scheduledDate;
            }
        }

        if (index === 2) {
            if (this.equipmentTemp.toDate < this.document.scheduledDate) {
                this.equipmentTemp.toDate = this.document.scheduledDate;
            }
        }
    }

    addEquipment() {
        this.document.detailLines[this.document.detailLines.indexOf(this.equipment)] = this.equipmentTemp;
        this.modalController.dismiss();
    }
}
